import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/common/ProtectedRoute";
import { Toaster } from "sonner";

import LandingPage from "./pages/LandingPage/LandingPage";
import SignupPage from "./pages/SignupPage/SignupPage";
import LoginPage from "./pages/LoginPage/LoginPage";
import UserDashboardPage from "./pages/DashboardPage/UserDashboardPage";
import ChatPage from "./pages/Chatpage/ChatPage";
import MyTeamsPage from "./pages/MyTeamsPage/MyTeamsPage";
import ManageTeamPage from "./imports/ManageTeamPage-54-266";
import HackathonListPage from "./pages/Hackathon/HackthonListPage";
import HackathonDetailPage from "./pages/Hackathon/HackathonDetailPage";
import HackathonRegistration from "./pages/Hackathon/HackathonRegistration";
import RegisterSuccessful from "./pages/Hackathon/RegisterSuccessful";
import RegistrationForm from "./pages/Hackathon/RegistrationForm";
import RegistrationSuccess from "./pages/Hackathon/RegistrationSuccess";
import MentorDashboardPage from "./pages/MentorDashboardPage/MentorDashboardPage";
import AdminDashboardPage from "./pages/AdminDashboardPage/AdminDashboardPage";
import JuryDashPage from "./pages/JuryDashboardPage/JuryDashPage";


import { SubmitIdea } from "./components/Ideas/SubmitIdea";
import { FinalSubmission } from "./components/Ideas/FinalSubmission";
import { MentorReview } from "./components/Ideas/MentorReview";
import IdeaListPage from "./pages/IdeaListPage/IdeaListPage";
import TrackingScreen from "./components/UserDashboard/TrackingScreen";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Toaster richColors position="top-right" />
        <Routes>

          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/login" element={<LoginPage />} />

          {/* ── USER DASHBOARD ── */}
          <Route
            path="/user-dashboard"
            element={
              <ProtectedRoute requiredRole="user">
                <UserDashboardPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/user-dashboard/tracking-screen"
            element={
              <ProtectedRoute requiredRole="user">
                <TrackingScreen />
              </ProtectedRoute>
            }
          />

          <Route
            path="/user-dashboard/my-teams"
            element={
              <ProtectedRoute requiredRole="user">
                <MyTeamsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/user-dashboard/my-teams/*"
            element={
              <ProtectedRoute requiredRole="user">
                <ManageTeamPage />
              </ProtectedRoute>
            }
          />

          {/* Hackathon Detail Page */}
          <Route
            path="/user-dashboard/hackathons"
            element={
              <ProtectedRoute requiredRole="user">
                <HackathonListPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/user-dashboard/hackathon-detail/:id"
            element={
              <ProtectedRoute requiredRole="user">
                <HackathonDetailPage />
              </ProtectedRoute>
            }
          />

          {/* Hackathon Registration Page */}
          <Route
            path="/user-dashboard/hackathon-registration/:id"
            element={
              <ProtectedRoute requiredRole="user">
                <HackathonRegistration />
              </ProtectedRoute>
            }
          />

          {/* Registration Successful Page */}
          <Route
            path="/user-dashboard/register-successful/*"
            element={
              <ProtectedRoute requiredRole="user">
                <RegisterSuccessful />
              </ProtectedRoute>
            }
          />

          {/* Registration Form Page */}
          <Route
            path="/user-dashboard/registration-form/*"
            element={
              <ProtectedRoute requiredRole="user">
                <RegistrationForm />
              </ProtectedRoute>
            }
          />

          {/* Registration Success Page */}
          <Route
            path="/user-dashboard/registration-success/*"
            element={
              <ProtectedRoute requiredRole="user">
                <RegistrationSuccess />
              </ProtectedRoute>
            }
          />

          {/* 🔥 IDEA WORKFLOW PAGES (Protected Routes) */}
          <Route
            path="/user-dashboard/submit-idea"
            element={
              <ProtectedRoute requiredRole="user">
                <SubmitIdea />
              </ProtectedRoute>
            }
          />

          <Route
            path="/user-dashboard/final-submission"
            element={
              <ProtectedRoute requiredRole="user">
                <FinalSubmission />
              </ProtectedRoute>
            }
          />

          <Route
            path="/user-dashboard/mentor-review"
            element={
              <ProtectedRoute requiredRole="user">
                <MentorReview />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-dashboard/chat"
            element={
              <ProtectedRoute requiredRole="user">
                <ChatPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-dashboard/idea-list"
            element={
              <ProtectedRoute requiredRole="user">
                <IdeaListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mentor-dashboard/*"
            element={
              <ProtectedRoute requiredRole="mentor">
                <MentorDashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin-dashboard/*"
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminDashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/jury-dashboard/*"
            element={
              <ProtectedRoute requiredRole="jury">
                <JuryDashPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
